export const common = {
  siteName: 'AllChinaBuy Spreadsheet',
  tagline: 'Ressources Produits, Vendeurs & Guides d\'Achat',
  explore: 'Explorer AllChinaBuy Spreadsheet',
  browseGuides: 'Parcourir les Guides d\'Achat',
  buyItNow: 'Acheter Maintenant',
  allchinabuySpreadsheet: 'AllChinaBuy Spreadsheet',
  visitMainSite: 'Visiter la Boutique Principale',
  searchPlaceholder: 'Rechercher des produits, vendeurs, livraison ou guides...',
  categories: 'Catégories',
  articles: 'Articles',
  guides: 'Guides',
  reviews: 'Avis',
  shipping: 'Livraison',
  coupon: 'Coupon',
  warehouse: 'Entrepôt',
  legit: 'Est-ce Légitime?',
  about: 'À Propos',
  contact: 'Contact',
  faq: 'FAQ',
  privacy: 'Politique de Confidentialité',
  terms: 'Conditions d\'Utilisation',
  disclaimer: 'Avertissement',
  home: 'Accueil',
  readMore: 'Lire la Suite',
  relatedArticles: 'Articles Connexes',
  tableOfContents: 'Table des Matières',
  lastUpdated: 'Dernière Mise à Jour',
  author: 'Auteur',
  share: 'Partager',
  question: 'Une Question?',
  ctaMainTitle: 'Prêt à Faire vos Achats?',
  ctaMainDesc: 'Visitez notre boutique principale pour le catalogue complet AllChinaBuy.',
  ctaMainButton: 'Aller à la Boutique Principale',
  footerDesc: 'AllChinaBuy Spreadsheet est votre ressource organisée pour les produits, vendeurs, guides de livraison et conseils d\'achat AllChinaBuy.',
  copyright: 'Tous droits réservés.',
  notAffiliated: 'Non affilié à AllChinaBuy. Ressource d\'information uniquement.',
  language: 'Langue',
  english: 'Anglais',
  french: 'Français',
  german: 'Allemand',
  danish: 'Danois',
  breadcrumbHome: 'Accueil',
  minutesRead: 'min de lecture',
  quickLinks: 'Liens Rapides',
  resources: 'Ressources',
  legal: 'Mentions Légales',
  scrollToTop: 'Haut de page',
  viewAll: 'Voir Tout',
  allProducts: 'Tous les Produits',
  buyNow: 'Acheter',
  productsPageTitle: 'Produits AllChinaBuy — Chaussures, Vêtements, Accessoires & Plus',
  productsPageDescription: 'Parcourez plus de 100 produits vérifiés du spreadsheet AllChinaBuy. Chaussures, sweats, t-shirts, vestes, accessoires, sacs, parfums et plus avec liens d\'achat directs.',
  pageNotFound: 'Page Non Trouvée',
  pageNotFoundDesc: 'La page que vous recherchez n\'existe pas.',
  featuredProducts: 'Produits en Vedette',
  featuredProductsDesc: 'Articles sélectionnés de notre catalogue AllChinaBuy',
  viewAllProducts: 'Voir Tous les Produits',
};

export const nav = {
  home: 'Accueil',
  products: 'Produits',
  categories: 'Catégories',
  articles: 'Articles',
  reviews: 'Avis',
  shipping: 'Livraison',
  coupon: 'Coupon',
  warehouse: 'Entrepôt',
  legit: 'Légitime?',
  about: 'À Propos',
};

export const hero = {
  h1: 'AllChinaBuy Spreadsheet — Trouvez Produits, Vendeurs & Ressources d\'Achat Plus Vite',
  subtitle: 'Explorez les ressources AllChinaBuy, produits, vendeurs, informations QC, guides de livraison, avis et conseils d\'achat en un seul endroit organisé.',
  ctaPrimary: 'Explorer AllChinaBuy Spreadsheet',
  ctaSecondary: 'Parcourir les Guides d\'Achat',
  searchPlaceholder: 'Rechercher des produits, vendeurs, livraison ou guides...',
};

export const categories = {
  title: 'Catégories Populaires AllChinaBuy',
  subtitle: 'Parcourez les catégories de produits les plus populaires sur AllChinaBuy',
  shoes: 'Chaussures',
  hoodiesSweaters: 'Sweats à Capuche & Pulls',
  tshirts: 'T-Shirts',
  jackets: 'Vestes',
  pantsShorts: 'Pantalons & Shorts',
  headwear: 'Couvre-Chefs',
  sets: 'Ensembles',
  underwear: 'Sous-Vêtements',
  jersey: 'Maillots',
  accessories: 'Accessoires',
  bags: 'Sacs',
  belts: 'Ceintures',
  perfumes: 'Parfums',
  otherStuff: 'Autres Articles',
  viewAll: 'Voir Toutes les Catégories',
};

export const homeSections = {
  popularSearchesTitle: 'Recherches Populaires AllChinaBuy',
  popularSearchesDesc: 'Découvrez ce que les acheteurs recherchent actuellement',
  spreadsheetHubTitle: 'Hub AllChinaBuy Spreadsheet',
  spreadsheetHubDesc: 'Votre ressource complète pour les informations produits et vendeurs organisées',
  resourcesTitle: 'Ressources Produits & Vendeurs',
  resourcesDesc: 'Guides complets pour vous aider à naviguer sur AllChinaBuy',
  reviewTitle: 'Avis AllChinaBuy',
  reviewDesc: 'Avis honnêtes et approfondis de vrais acheteurs et de notre équipe éditoriale',
  shippingTitle: 'Coût de Livraison AllChinaBuy',
  shippingDesc: 'Comparez les méthodes de livraison, lignes, délais et coûts pour votre région',
  couponTitle: 'Coupon & Code de Réduction',
  couponDesc: 'Derniers coupons vérifiés, codes promo et offres pour AllChinaBuy',
  warehouseTitle: 'Guide Entrepôt',
  warehouseDesc: 'Comprendre le fonctionnement des entrepôts AllChinaBuy et optimiser votre stockage',
  legitTitle: 'AllChinaBuy est-il Légitime?',
  legitDesc: 'Guide de sécurité, analyse de confiance et sensibilisation aux arnaques pour les acheteurs AllChinaBuy',
  comparisonTitle: 'Tableaux de Comparaison',
  comparisonDesc: 'Voyez comment AllChinaBuy se compare aux autres agents d\'achat',
  articlesTitle: 'Derniers Articles',
  articlesDesc: 'Guides, conseils et actualités frais pour les acheteurs AllChinaBuy',
  faqTitle: 'Questions Fréquemment Posées',
  faqDesc: 'Réponses rapides aux questions courantes sur AllChinaBuy',
  finalCtaTitle: 'Commencez Votre Voyage AllChinaBuy',
  finalCtaDesc: 'Visitez notre boutique principale pour le catalogue complet et les dernières offres.',
  finalCtaButton: 'Visiter la Boutique Principale',
};

export const articles = {
  allchinabuySpreadsheetGuide: 'Guide AllChinaBuy Spreadsheet: Répertoire Produits & Vendeurs Complet 2026',
  allchinabuySpreadsheetGuideDesc: 'Le guide le plus complet pour utiliser les spreadsheets AllChinaBuy. Apprenez à trouver des produits, vendeurs, photos QC et infos de livraison plus vite.',
  allchinabuyReview2026: 'Avis AllChinaBuy 2026: Fonctionnalités, Livraison & Guide d\'Achat',
  allchinabuyReview2026Desc: 'Un avis honnête sur les fonctionnalités, avantages, inconvénients, livraison et expérience d\'achat AllChinaBuy. Mis à jour pour 2026.',
  allchinabuyShippingCost: 'Coût de Livraison AllChinaBuy: Guide Complet & Comparaison',
  allchinabuyShippingCostDesc: 'Comparez les lignes de livraison, coûts, délais de livraison et conseils douaniers pour les commandes AllChinaBuy.',
  allchinabuyCoupon: 'Coupon & Code de Réduction AllChinaBuy: Guide des Dernières Offres',
  allchinabuyCouponDesc: 'Trouvez les derniers coupons vérifiés, codes de réduction et promotions AllChinaBuy.',
  allchinabuyWarehouseGuide: 'Guide Entrepôt AllChinaBuy: Stockage, QC & Livraison',
  allchinabuyWarehouseGuideDesc: 'Tout ce que vous devez savoir sur les entrepôts AllChinaBuy, le stockage et le contrôle qualité.',
  isAllchinabuyLegit: 'AllChinaBuy est-il Légitime? Guide Sécurité & Confiance 2026',
  isAllchinabuyLegitDesc: 'Analyse de sécurité, indicateurs de confiance, sensibilisation aux arnaques et conseils pour acheter en toute sécurité sur AllChinaBuy.',
  allchinabuyVsSuperbuy: 'AllChinaBuy vs Superbuy: Comparaison Détaillée 2026',
  allchinabuyVsSuperbuyDesc: 'Comparaison côte à côte des fonctionnalités, livraison, QC et tarifs d\'AllChinaBuy et Superbuy.',
  allchinabuyBeginnerGuide: 'Guide Débutant AllChinaBuy: Comment Acheter Étape par Étape',
  allchinabuyBeginnerGuideDesc: 'Nouveau sur AllChinaBuy? Ce guide étape par étape vous accompagne de l\'inscription à la livraison.',
};

export const articleContent = {
  spreadsheetGuideTitle: 'Guide AllChinaBuy Spreadsheet: Répertoire Produits & Vendeurs Complet 2026',
  spreadsheetGuideIntro: 'AllChinaBuy est devenu l\'un des agents d\'achat les plus populaires pour les acheteurs internationaux cherchant à s\'approvisionner sur les marchés chinois. Que vous recherchiez des baskets, des vêtements de rue, des accessoires ou des trouvailles de niche, l\'écosystème de spreadsheets AllChinaBuy vous aide à organiser les liens produits, les informations vendeurs, les photos QC et les tarifs en un seul endroit. Ce guide est la ressource la plus complète pour comprendre comment utiliser les spreadsheets AllChinaBuy pour faire vos achats plus intelligemment, économiser de l\'argent et éviter les erreurs courantes.',
  whatIsSpreadsheetTitle: 'Qu\'est-ce qu\'un AllChinaBuy Spreadsheet?',
  whatIsSpreadsheetContent: 'Un AllChinaBuy Spreadsheet est un document ou une base de données organisée contenant des liens vers des produits, vendeurs et ressources d\'achat sur AllChinaBuy. Ces spreadsheets peuvent inclure des catégories comme chaussures, vêtements, accessoires, sacs et plus. Ils contiennent souvent les noms de produits, noms de vendeurs, prix, liens de photos QC, tableaux de tailles et liens d\'achat directs. L\'objectif est de faire gagner du temps aux acheteurs en fournissant une manière structurée de parcourir et comparer les produits sans rechercher manuellement dans les marchés.',
  whyUseSpreadsheetTitle: 'Pourquoi Utiliser les Spreadsheets AllChinaBuy?',
  whyUseSpreadsheetContent1: 'Gagnez du temps — Les spreadsheets vous donnent des liens directs vers des produits et vendeurs de confiance.',
  whyUseSpreadsheetContent2: 'Comparez les prix — Voir les prix pour des produits similaires chez différents vendeurs en une vue.',
  whyUseSpreadsheetContent3: 'Photos QC — Beaucoup de spreadsheets incluent des liens vers des photos de contrôle qualité.',
  whyUseSpreadsheetContent4: 'Vendeurs de confiance — Les spreadsheets organisés mettent en avant les vendeurs avec de bons avis.',
  whyUseSpreadsheetContent5: 'Communautaire — Les meilleurs spreadsheets sont maintenus par des communautés d\'acheteurs.',
  howToUseSpreadsheetTitle: 'Comment Utiliser un AllChinaBuy Spreadsheet',
  howToUseSpreadsheetContent: 'Utiliser un AllChinaBuy Spreadsheet est simple. Identifiez d\'abord la catégorie qui vous intéresse — chaussures, sweats, accessoires. Ouvrez le spreadsheet et parcourez l\'onglet pertinent. Chaque ligne contient généralement le nom du produit, le vendeur, le prix et un lien. Cliquez sur le lien pour voir le produit sur la marketplace. Avant d\'acheter, vérifiez s\'il y a des photos QC et lisez les notes du curateur. Ajoutez le produit à votre panier AllChinaBuy, soumettez l\'achat et attendez l\'arrivée à l\'entrepôt. Une fois arrivé, examinez les photos QC et approuvez ou demandez un retour.',
  popularCategoriesTitle: 'Catégories Populaires des Spreadsheets AllChinaBuy',
  popularCategoriesContent: 'Les catégories les plus populaires incluent chaussures et baskets, sweats et pulls, t-shirts, vestes, pantalons et shorts, couvre-chefs, accessoires, sacs, ceintures et parfums. Chaque catégorie a ses propres vendeurs de confiance et gammes de produits. Par exemple, les spreadsheets de chaussures incluent souvent des répliques et trouvailles authentiques de marques populaires, tandis que les spreadsheets d\'accessoires couvrent montres, bijoux, étuis de téléphone et plus.',
  spreadsheetTipsTitle: 'Conseils pour Profiter au Maximum des Spreadsheets',
  spreadsheetTipsContent1: 'Vérifiez toujours la réputation du vendeur avant d\'acheter — consultez les avis et retours récents.',
  spreadsheetTipsContent2: 'Comparez les prix entre plusieurs spreadsheets — différents curateurs peuvent avoir différentes offres.',
  spreadsheetTipsContent3: 'Rejoignez des communautés — Discord, Reddit et Telegram partagent souvent les spreadsheets les plus récents.',
  spreadsheetTipsContent4: 'Vérifiez attentivement les photos QC — ce que vous voyez dans le spreadsheet peut différer légèrement du produit final.',
  spreadsheetTipsContent5: 'Sauvegardez vos spreadsheets favoris — mettez-les en favoris pour revenir vérifier les mises à jour.',
  comparisonTitle: 'AllChinaBuy vs Autres Agents d\'Achat',
  comparisonContent: 'En comparant AllChinaBuy à d\'autres agents comme Superbuy, CSSBuy, Sugargoo et Basetao, chaque plateforme a ses forces. AllChinaBuy est populaire pour son approche compatible avec les spreadsheets et le partage communautaire. Superbuy offre un logiciel plus élaboré et un meilleur support client. CSSBuy est connu pour ses tarifs de livraison compétitifs. Sugargoo a une interface conviviale. Basetao offre un service fiable et établi. Pour les utilisateurs de spreadsheets, AllChinaBuy est souvent préféré car sa communauté partage et maintient activement des listes de produits.',
  faqQuestion1: 'Les spreadsheets AllChinaBuy sont-ils gratuits?',
  faqAnswer1: 'Oui, la plupart des spreadsheets AllChinaBuy sont gratuits et partagés par des membres de la communauté. Certains curateurs peuvent proposer des spreadsheets premium avec des trouvailles exclusives moyennant un petit frais.',
  faqQuestion2: 'À quelle fréquence les spreadsheets sont-ils mis à jour?',
  faqAnswer2: 'Cela dépend du curateur. Les spreadsheets communautaires actifs sont mis à jour hebdomadairement ou mensuellement. Vérifiez toujours la date de dernière mise à jour.',
  faqQuestion3: 'Peut-on faire confiance à tous les vendeurs d\'un spreadsheet?',
  faqAnswer3: 'Tous les vendeurs ne sont pas également fiables. Les spreadsheets réputés incluent généralement des notes sur la qualité du vendeur. Vérifiez toujours les avis récents et les photos QC.',
  faqQuestion4: 'Que faire si un lien produit est cassé?',
  faqAnswer4: 'Si un lien est cassé, essayez de rechercher le nom du produit ou du vendeur directement sur la marketplace. Vous pouvez aussi demander au curateur du spreadsheet ou à la communauté un lien mis à jour.',
  conclusionTitle: 'Conclusion',
  conclusionContent: 'Les spreadsheets AllChinaBuy sont un outil inestimable pour les acheteurs internationaux qui veulent gagner du temps, comparer des produits et acheter en toute confiance. En utilisant des spreadsheets organisés, vous pouvez accéder à des vendeurs de confiance, des photos QC et des catégories de produits organisées en un seul endroit. Que vous soyez débutant ou acheteur expérimenté, ce guide vous donne tout ce dont vous avez besoin pour utiliser efficacement les spreadsheets AllChinaBuy en 2026.',
  backToHome: 'Retour à l\'Accueil',
  nextArticle: 'Article Suivant',
  prevArticle: 'Article Précédent',
  writtenBy: 'Écrit par',
  publishedOn: 'Publié le',
  updatedOn: 'Mis à jour le',
  readingTime: 'Temps de lecture',
};

export default {
  ...common,
  ...nav,
  ...hero,
  ...categories,
  ...homeSections,
  ...articles,
  ...articleContent,
};